import React from 'react'

import useAnalyticsComponentViewed from 'hooks/useAnalyticsComponentViewed'
import { GIFTS_SECTION } from 'utils/testing/testIDs'

import { OPTIONS, SECTION_NAMES, baseAnalyticsOptions } from '../analytics'
import { GiftType, getImagePath } from '../helpers'
import { ArticleButton } from '../shared/ArticleButton/ArticleButton'
import { Container, Content } from '../shared/SectionDetails'
import { Detail } from './Detail/Detail'
import { Interactive } from './Interactive/Interactive'
import {
  MdBeigeVector,
  MdDuskRectangle,
  ShapeContainer,
  SmLightOakCircle,
} from './styled-components'

const Gifts = ({
  beneficiaryId,
  beneficiaryName,
  contributionByOthers,
  gifts,
  investmentAccountId,
}: {
  beneficiaryId: string
  beneficiaryName: string
  contributionByOthers: string
  gifts: GiftType[]
  investmentAccountId: string
}): React.ReactElement => {
  const inViewContainerRef = useAnalyticsComponentViewed({
    action: 'Viewed',
    payload: {
      ...baseAnalyticsOptions,
      ...OPTIONS.GIFTS,
      beneficiaryId,
      event_description: 'Early Quarterly Recaps Gifts Section Viewed',
      object: 'Screen',
      object_name: 'earlyQuarterlyRecapsGiftsSection',
    },
  })

  return (
    <Container data-testid={GIFTS_SECTION} ref={inViewContainerRef}>
      <Content zIndex="2">
        <ArticleButton
          beneficiaryId={beneficiaryId}
          section={SECTION_NAMES.GIFTS}
        />
        <Detail
          beneficiaryName={beneficiaryName}
          contributionByOthers={contributionByOthers}
          gifts={gifts}
          investmentAccountId={investmentAccountId}
        />
        <Interactive gifts={gifts} />
      </Content>
      <ShapeContainer>
        <MdDuskRectangle src={getImagePath('medium-dusk-rectangle')} />
        <MdBeigeVector src={getImagePath('medium-beige-vector')} />
        <SmLightOakCircle src={getImagePath('small-circle')} />
      </ShapeContainer>
    </Container>
  )
}

export { Gifts }
